import {
    getAvailableCountries,
    mapCountryCodeToCountryKey
} from 'tradera/localization/countries';

const topCountries = ['se', 'dk', 'fi', 'de', 'no', 'nl', 'fr'];

export const getAvailableUserRegistrationCountries = (t) => {
    return [
        ...topCountries.map((code) => ({
            code,
            name: t(mapCountryCodeToCountryKey(code))
        })),
        { code: null, name: ' ' },
        ...getAvailableCountries(t)
    ];
};
